export default {
  jp: {
    title: {
      list: '会社一覧'
    },
    error: {
      companyId: {
        notExist: '会社は存在しないか削除されています。最新の情報を確認してください。',
        undeletable: '関連するデータが存在するため削除できません。'
      },
      companyName: {
        required: '会社名は入力必須項目です。',
        maxLength: '会社名は100文字以内で入力してください。',
        existInSmallGroup: '指定されたグループ分類に同じ会社名の会社が既に存在します。'
      },
      companyNameKana: {
        required: '会社名カナは入力必須項目です。',
        maxLength: '会社名カナは100文字以内で入力してください。',
        invalid: '会社名カナは全角カナ、・、－で入力してください。'
      },
      displayOrder: {
        maxLength: '表示順は0以上9999以下の数値で入力してください。'
      },
      groupSmallId: {
        required: 'グループ分類は入力必須項目です。',
        notExist: 'グループ分類は存在しないか削除されています。最新の情報を確認してください。',
        invalid: '不正なグループ分類です。',
        existUnavailableServices: '変更後のグループ分類では現在利用可能なサービスが利用できなくなるため、変更できません。 利用できなくなるサービス : [##UNAVAILABLE_SERVICE_NAMES##]'
      }
    }
  },
  en: {
  }
}
